export default __webpack_public_path__ + "static/media/00-principal_preview.bd05213a.jpg";